import { translate } from "../../../../translations/index.ts";
import styles from "../createGame.module.css";
import { useMemo } from "react";

export default function ConfirmationStep({ template, parties, submit }) {
  const selectedParties = template.parties.map((id) =>
    parties.find((p) => p._id === id),
  );
  const selectedSettings = useMemo(
    () =>
      [
        template.skipQuestions &&
          "teacher.gameSettings.steps.confirmation.skipQuestions",
        template.ownArguments &&
          "teacher.gameSettings.steps.confirmation.enterArguments",
        template.ownTempo && "teacher.gameSettings.steps.confirmation.ownTempo",
      ].filter((v) => v !== false),
    [template],
  );

  return (
    <section>
      <div className={styles.confirmContainer}>
        <p className={styles.confirmTitle}>
          {translate("teacher.gameSettings.steps.confirmation.name")}:{" "}
        </p>
        <p className={styles.gameSetting}>{template.name}</p>
      </div>
      <div className={styles.confirmContainer}>
        <p className={styles.confirmTitle}>
          {translate("teacher.gameSettings.steps.confirmation.parties")} (
          {selectedParties.length})
        </p>
        <p className={styles.gameSetting}>
          {selectedParties.map((p) => p.name).join(", ")}
        </p>
      </div>
      <div className={styles.confirmContainer}>
        <p className={styles.confirmTitle}>
          {translate("teacher.gameSettings.steps.confirmation.statementsCount")}
          :
        </p>
        <p className={styles.gameSetting}>{template.statements.length}</p>
      </div>
      <div className={styles.confirmContainer}>
        {selectedSettings.length > 0 && (
          <ul>
            {selectedSettings.map((setting, index) => (
              <li key={index}>{translate(setting)}</li>
            ))}
          </ul>
        )}
      </div>
      <div className={styles.confirmControlsWrapper}>
        <button className="button" onClick={() => submit(template)}>
          {translate([
            "teacher",
            "gameSettings",
            template._id ? "edit" : "create",
            "submit",
          ])}
        </button>
      </div>
    </section>
  );
}
